import * as React from 'react';

interface Props {
  ariaName?: string;
}

export const CouponIcon: React.FunctionComponent<Props> = ({ ariaName }) => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <title>{ariaName}</title>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1 3V5.17071C2.16519 5.58254 3 6.69378 3 8C3 9.30622 2.16519 10.4175 1 10.8293V13H15V3H1ZM11.4868 12C10.4164 12 9.84292 11.2365 9.83927 10.3379V9.94338C9.84292 9.04475 10.4311 8.28128 11.4868 8.28128C12.5607 8.28128 13.1379 9.03744 13.1342 9.94338V10.3379C13.1379 11.2365 12.5461 12 11.4868 12ZM7.64384 7.71142C6.57717 7.71142 6.00365 6.95525 6 6.05662V5.6621C6.00365 4.75616 6.59909 4 7.64384 4C8.72146 4 9.29863 4.75616 9.29498 5.6621V6.05662C9.29863 6.96256 8.70685 7.71142 7.64384 7.71142ZM7.31142 11.7406H6.35799L11.5014 4.25936H12.4548L7.31142 11.7406ZM11.4868 9.21644C11.0484 9.21644 10.9059 9.58539 10.9023 9.94338V10.3379C10.9059 10.6849 11.0411 11.0575 11.4868 11.0575C11.9324 11.0575 12.0676 10.6959 12.0639 10.3379V9.94338C12.0676 9.58539 11.947 9.21644 11.4868 9.21644ZM7.64384 4.93516C7.20913 4.93516 7.07397 5.31507 7.07032 5.6621V6.05662C7.07397 6.41461 7.21279 6.77626 7.64384 6.77626C8.0895 6.77626 8.22831 6.41461 8.22466 6.05662V5.6621C8.22831 5.30411 8.10411 4.93516 7.64384 4.93516Z"
        fill="#008574"
      />
    </svg>
  );
};
